import type PersonaControlViewState from './PersonaControlViewState';

export enum LivePersonaCardInitializationState {
    NotInitialized = 'NotInitialized',
    Initializing = 'Initializing',
    Initialized = 'Initialized',
    Failed = 'Failed',
}

export enum LivePersonaEditorInitializationState {
    NotInitialized = 'NotInitialized',
    Initializing = 'Initializing',
    Initialized = 'Initialized',
    Failed = 'Failed',
}

interface PersonaControlStore {
    viewStates: Map<string, PersonaControlViewState>;
    livePersonaCardInitializationStatus: {
        state: LivePersonaCardInitializationState;
        timestamp: number;
    };
    livePersonaEditorInitializationStatus: {
        state: LivePersonaEditorInitializationState;
        timestamp: number;
    };
    // TODO: Retire isLivePersonaCardInitialized once consumers switch to livePersonaCardInitializationStatus
    isLivePersonaCardInitialized: boolean;
    isLivePersonaEditorInitialized: boolean;
    isPersonaCardDisabled: boolean;
    /**
     * Tracks whether the persona card is currently open
     */
    isPersonaCardOpen: boolean;
    /**
     * Dynamic set of email addresses we know are brands that is populated at runtime.
     * Represented as map of emailAddress -> true, since mobx doesn't support observable
     * sets. See https://github.com/mobxjs/mobx/issues/69 and https://github.com/mobxjs/mobx/issues/2043
     *
     * Stored separately from the above static brand list to avoid recalculating
     * the brands smtp set.
     */
    dynamicBrandSets: {
        unverifiedBrands: Map<string, boolean>;
        verifiedBrands: Map<string, boolean>;
    };
}

export default PersonaControlStore;
